module.exports = __webpack_public_path__ + "img/RMR Home Page - NEW.c207fe53.png";